import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import CategoryPage from "../views/CategoryPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/CheckoutPage.vue"),
  },
  {
    path: "/AboutUs",
    name: "about_us",
    component: () => import("@/views/AboutUs.vue"),
  },
  {
    path: "/Contactus",
    name: "contact_us",
    component: () => import("@/views/ContactUs.vue"),
  },
  {
    path: "/Question",
    name: "question",
    component: () => import("@/views/QuEstion.vue"),
  },
  {
    path: "/shipping_delivery",
    name: "shipping_delivery",
    component: () => import("@/views/ShippingDelivery.vue"),
  },
  {
    path: "/return_refund",
    name: "return_refund",
    component: () => import("@/views/RefundReturn.vue"),
  },
  {
    path: "/confidentiality",
    name: "confidentiality",
    component: () => import("@/views/KhossoSia.vue"),
  },
  {
    path: "/categories",
    name: "categories",
    component: CategoryPage,
  },
  {
    path: "/products",
    name: "products_category",
    component: () => import("@/views/ProductCategory.vue"),
  },
  {
    path: "/book-request",
    name: "book_request",
    component: () => import("@/views/OtHer.vue"),
  },
  {
    path: "/login/adminpage",
    name: "login_page",
    component: () => import("@/views/ComfiPage.vue"),
  },
  {
    path: "/productsdetails",
    name: "products_details",
    component: () => import("@/views/ProductDetails.vue"),
  },
  {
    path: "/PageNotFound",
    name: "PageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
  },
  {
    path: "/search-results",
    name: "searchResults",
    component: () => import("@/views/SearchResults.vue"), // Define the route for search results
  },
  {
    path: "/CategoryNotFound",
    name: "CatNotFound",
    component: () => import("@/views/CatNotFound.vue"),
  },
  {
    path: "/order-success",
    name: "OrderSuccess",
    component: () => import("@/views/OrderSuccess.vue"), // Lazy-load the success page
  },
  {
    path: "/order-successS",
    name: "OrderSuccessS",
    component: () => import("@/views/OrderSuccessS.vue"), // Lazy-load the success page
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/PnF.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
